import React, { useState, useEffect, useRef} from 'react';
//import Recipe from './recipe';
import '../styles/blocks/chef.scss'

// const chef1 = 'Paul';
// const chef2 = 'Dustion';

const root = document.querySelector('#render-react-chefs');

const Chefs = () => {   
    const chef1_name = root.getAttribute('chef1_name') ? root.getAttribute('chef1') : false;
    const chef2_name = root.getAttribute('chef2_name') ? root.getAttribute('chef2') : false;
    const chef1_img = root.getAttribute('chef1_img') ? root.getAttribute('chef1_img') : false;
    const chef2_img = root.getAttribute('chef2-_img') ? root.getAttribute('chef2_img') : false;
    const chef1_copy = root.getAttribute('chef1_copy') ? root.getAttribute('chef1_copy') : false;
    const chef2_copy = root.getAttribute('chef2_copy') ? root.getAttribute('chef2_copy') : false;
    const chef1 = {
        'name': chef1_name,
        'img': chef1_img,
        'copy': chef1_copy
    }
    const chef2 = {
        'name': chef2_name,
        'img': chef2_img,
        'copy': chef2_copy
    }

    const handleChefClick = (chef) => {
        setActiveChef(chef);
        setShowState(true);
    }
    const [active_chef,setActiveChef] = useState(null);
    const [show_state, setShowState] = useState(false)

    console.log('chefs',chef1, chef2);

    return(
        <div className={show_state ? "meet-chef__wrapper meet-chef__wrapper--shift" : "meet-chef__wrapper" }>
            <div className="meet-chef__title">
                <h2>Meet Chef {chef1_name} 
                    {chef2_name && 
                        (
                            "& Chef " + chef2_name
                        )
                    }
                </h2>
                <p>Click on each Chef to find out more about them!</p>
            </div>
            <div className="meet-chef__image">
                <figure className='chef1' >
                    <img src={chef1_img} onClick={() => handleChefClick(chef1)}/>
                    <figcaption>Chef {chef1_name}</figcaption>
                </figure>
                <figure className='chef2'>
                    <img src={chef2_img} onClick={() => handleChefClick(chef2)}/>
                    <figcaption>Chef {chef2_name}</figcaption>
                </figure>
            </div>
            <div className={show_state ? "meet-chef__copy": "meet-chef__copy meet-chef__copy--hide"} >
                {show_state ?
                (
                    <>
                    <h3>Chef {active_chef.name}</h3>
                    <div dangerouslySetInnerHTML={{ __html: active_chef.copy}}></div>
                    </>
                )
                :
                null
                }
            </div>
        </div>
    )
}

export default Chefs;